import type { AuthState } from "@jetblue/kit-auth";
import type { EnhancedUserData } from "./kit-auth-map-profile";

type AuthStatusInput = {
  combinedError: unknown;
  isLoadingKitAuth: boolean;
  isLoadingProfile: boolean;
  profile?: EnhancedUserData;
};

export function getAuthStatus({
  combinedError,
  isLoadingKitAuth,
  isLoadingProfile,
  profile,
}: AuthStatusInput): AuthState {
  if (combinedError) {
    return "unauthenticated";
  }

  if (profile) {
    return "authenticated";
  }

  const isAuthenticating = isLoadingKitAuth || isLoadingProfile;
  if (isAuthenticating) {
    return "authenticating";
  }

  return "unauthenticated";
}
